"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function Overview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="161703" id="additional-information" className="w-full bg-background text-foreground">
      <div className="w-full bg-background px-6 py-[120px]">
        <div ref={ref} className={`mx-auto flex max-w-[800px] flex-col items-center text-center transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <p className="font-sans text-[18px] leading-[1.6] text-foreground">
            PARTNERSHIP — Our strategic approach is built on a foundation of transparency and long-term alignment. We offer NZ-based pricing to ensure that our clients receive exceptional value and local accountability while we deliver innovative solutions that empower organizations to achieve their strategic objectives.
          </p>
          <Separator className="mt-[40px] w-full bg-border" />
        </div>
      </div>
    </section>;
}